import { postJSON } from "@whatslly/commons/apiUtils";
import ms from "ms";
import { LogsQueueType } from "@whatslly/commons/frontLogger/types";
import { getPod } from "@whatslly/commons/browserUtils";

const LOG_LEVEL = (() => {
  if (import.meta.env.VITE_LOG_LEVEL === "info") {
    return ["error", "warn", "info"];
  }
  if (import.meta.env.VITE_LOG_LEVEL === "debug") {
    return ["error", "warn", "info", "debug"];
  }
  return ["error"];
})();

const SEND_LOG = (import.meta.env.VITE_SEND_LOG ?? "false") !== "false";

const shipLogs = async (queue: LogsQueueType[], etoken?: string): Promise<void> => {
  return await postJSON({
    urlSuffix: "/analytics/v2/logger/log",
    pod: getPod(),
    etoken,
    body: JSON.stringify(queue),
  });
};

class LoggerListener {
  private logsQueue: LogsQueueType[] = [];
  private etoken: string | undefined;
  private _waitLockResolve: undefined | ((value?: unknown) => void) = undefined;
  private _waitLock = new Promise((resolve) => {
    this._waitLockResolve = resolve;
  });

  startInterval() {
    this.sendLogs().catch();

    setInterval(async () => {
      await this.sendLogs();
    }, ms("5sec"));
  }

  async addLog(request: { data: any }, etoken?: string) {
    if (!LOG_LEVEL.includes(request.data.level) || !SEND_LOG) {
      return;
    }
    await this.waitForUnLock();
    if (etoken) {
      this.etoken = etoken;
    }
    this.logsQueue.push(request.data);
    return;
  }

  async sendLogs() {
    this.lock();

    const length = this.logsQueue.length;

    if (!length) {
      this.releaseLock();
      return;
    }

    await shipLogs(this.logsQueue, this.etoken);
    this.logsQueue.splice(0, length);

    this.releaseLock();
  }

  private lock() {
    this._waitLock = new Promise((resolve) => {
      this._waitLockResolve = resolve;
    });
  }

  private releaseLock() {
    if (this._waitLockResolve) {
      this._waitLockResolve();
    }
  }

  private waitForUnLock() {
    return this._waitLock;
  }
}

export const loggerListener = new LoggerListener();
